import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';
import { createFilterValidator } from './validator';

const filterAction = {
  ...createDefaultActionDefinition(StylesDerivedNativeActions.filterStyles),
  validator: createFilterValidator(),
};

export default filterAction;
